import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@workspace/lib';
import { theme } from '../../theme';

const textareaVariants = cva(
  'border placeholder:text-secondary-200 bg-white outline-none focus:outline-none focus-visible:outline-none rounded-sm p-3 w-full block hover:bg-secondary-50 focus-visible:border-secondary-200 focus-within:border-secondary-200 focus-within:shadow-focus focus-visible:!bg-white',
  {
    variants: {
      status: {
        default: 'border-secondary-100 border-sm',
        error: 'border-error !border-md focus-visible:!border-sm',
        success: 'border-success border-sm',
      },
      site: {
        porta: '',
        portaNZ: '',
        redRec: '',
        easycraft: '',
      },
      isDisabled: {
        true: 'bg-secondary-100 cursor-not-allowed',
        false: '',
      },
    },
    compoundVariants: [
      {
        site: 'redRec',
        status: 'default',
        class: 'border-primary',
      },
    ],
    defaultVariants: {
      status: 'default',
      isDisabled: false,
    },
  },
);

interface TextAreaProps {
  id?: string;
  name?: string;
  placeholder: string;
  value?: string;
  isDisabled?: boolean;
  status?: VariantProps<typeof textareaVariants>['status'];
  errorMessage?: string;
  className?: string;
  maxLength?: number;
  //
  onBlur?: () => void;
  onChange: (value: string) => void;
}

export const TextArea = ({
  id,
  name,
  placeholder,
  value = '',
  isDisabled = false,
  status = 'default',
  errorMessage,
  className = '',
  maxLength,
  onChange,
  onBlur,
}: TextAreaProps) => {
  const wordCount = value ? value.length : 0;
  const limit = maxLength ?? 1000;

  return (
    <div className="w-full">
      <textarea
        id={id}
        name={name}
        placeholder={placeholder}
        value={value}
        maxLength={maxLength}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        disabled={isDisabled}
        className={cn(textareaVariants({ status, isDisabled, site: theme }), className)}
      />
      <div className="flex justify-between items-center mt-xs">
        {errorMessage && <span className="text-xs text-error">{errorMessage}</span>}
        <span className="text-base text-secondary-700 text-right ml-auto">
          {wordCount}/{limit}
        </span>
      </div>
    </div>
  );
};
